import { Flex, Stack, Text } from '@chakra-ui/react'

import { AppSettings } from '@/appSettings'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { usePartner } from '@/context/PartnerContext'

import { ContentLabel } from './Insurer'

const baseUrl = AppSettings.baseUrl + '/docs/colonnade/'

const ColonnadeContent = () => {
  return (
    <Stack m={4} gap={10}>
      <Documents />
    </Stack>
  )
}

export default ColonnadeContent

const Documents = () => {
  const { currentPartner } = usePartner()

  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={6} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <ContentLabel label='AutoCheck / Záruka' />
        <DocumentsList items={[
          {
            url: baseUrl + 'Colonnade_AutoCheck_informace_k_produktu.pptx',
            name: 'Colonnade AutoCheck informace k produktu',
            documentType: 'pptx'
          },
          {
            url: baseUrl + 'COL-AutoCheck-IPID.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-AutoCheck–VPP_ALD_0520.pdf',
            name: 'Všeobecné pojistné podmínky',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-AutoCheck-Zvlastni-podminky-Platinum.pdf',
            name: 'Zvláštní podmínky - Platinum',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-AutoCheck-Zvlastni-podminky-TOP-GOLD-SILVER-BRONZE.pdf',
            name: 'Zvláštní podmínky - TOP Gold, Silver, Bronze',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-Klicova-fakta-AutoCheck-Platinum.pdf',
            name: 'Klíčová fakta - Platinum',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-Klicova-fakta-AutoCheck-TOP.pdf',
            name: 'Klíčová fakta - TOP Gold, Silver, Bronze',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-Prehled-krytych-soucastek-pro-programy-Gold-Silver-Bronze.pdf',
            name: 'Přehled krytých součástek pro programy Gold, Silver, Bronze',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-Kryte-soucastky-Gold.pdf',
            name: 'Kryté součástky - Gold',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-Kryte-soucastky-Silver.pdf',
            name: 'Kryté součástky - Silver',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-Kryte-soucastky-Bronze.pdf',
            name: 'Kryté součástky - Bronze',
            documentType: 'pdf'
          }
        ]} />

        <ContentLabel label='GAP' />
        <DocumentsList items={[
          {
            url: baseUrl + 'Colonnade_GAP_informace_k_produktu.pptx',
            name: 'Colonnade GAP informace k produktu',
            documentType: 'pptx'
          },
          {
            url: baseUrl + 'COL-GAP-IPID.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-GAP-VPP_ALD_0520_VPP_GAP.pdf',
            name: 'Všeobecné pojistné podmínky',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'COL-GAP-Zvlastni-podminky_0518_ZPP_GAP.pdf',
            name: 'Zvláštní podmínky',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'Colonnade_Gap-cenik_2023.pdf',
            name: 'Ceník 2023',
            documentType: 'pdf'
          }
        ]} />

        {currentPartner?.partner === 'Jap' && <>
          <ContentLabel label='Manuál' />
          <DocumentsList items={[
            {
              url: baseUrl + 'Colonnade_manual-pro-obchodni-sit.pdf',
              name: 'Manuál pro obchodní síť',
              documentType: 'pdf'
            }
          ]} />
        </>}
      </Stack>
    </Stack >
  )
}